import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { GetDeleteArticleSlice } from "../../../../redux/features/Publish Article By Admin Slices/DeletedArticle";
import useParamsFormat from "../../../../common/Params Values format/ParamsFormat";
import TableSkeleton from "../../../../common/Skeleton";
import NotFoundData from "../../../../common/NotFoundData";
import CustomPagination from "../../../../common/Pagination/Pagination";
import useRemoveTag from "../../../../common/Remove Tag of ReactQuil/RemoveTag";

const DeleteArticles = () => {
  const location = useLocation().pathname.split("/").splice(1);

  const { pageNo } = useParams();
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({});
  const [iState, setUpdate] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [dataForHold, setDataForHold] = useState({
    filterTheData: true,
  });
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: pageNo ?? 1,
  });
  const [timeFrame, setTimeFrame] = useState("");

  const { loading, AllDeleteArticle } = useSelector((state) => state?.Delete);
  const { DeletedArticle, DisApprovedArticle, HideArticle } = useSelector(
    (state) => state?.Article
  );

  const { getPlainText } = useRemoveTag();

  useEffect(() => {
    dispatch(GetDeleteArticleSlice(createDataSetParams(getSearch))).then(
      (res) => {
        setPagination(res?.payload?.data?.pagination);
      }
    );
  }, [
    DeletedArticle,
    DisApprovedArticle,
    HideArticle,
    dataForHold?.filterTheData,
  ]);

  useEffect(() => {
    setUpdate(AllDeleteArticle);
  }, [AllDeleteArticle]);

  const hanldeFetchData = (PageNumber) => {
    setGetSearch((prev) => ({ ...prev, page: PageNumber }));
    dispatch(
      GetDeleteArticleSlice(
        createDataSetParams({ ...getSearch, page: PageNumber })
      )
    ).then((res) => {
      setPagination(res?.payload?.data?.pagination);
    });
  };

  const handleReset = () => {
    if (
      getSearch?.search?.length === 0 &&
      getSearch?.toDate?.length === 0 &&
      getSearch?.fromDate?.length === 0 &&
      timeFrame?.length === 0
    )
      return;
    setGetSearch((prev) => ({ ...prev, search: "", fromDate: "", toDate: "" }));

    setTimeFrame("");

    setDataForHold((prev) => ({
      ...prev,
      filterTheData: !prev["filterTheData"],
    }));
  };

  const handleTimeFrame = (e) => {
    const selectedValue = e?.target?.value?.trim();

    if (!selectedValue) return;

    setGetSearch((prev) => ({ ...prev, search: "", fromDate: "", toDate: "" }));

    setTimeFrame(selectedValue);

    setDataForHold((prev) => ({ ...prev, timeframe: selectedValue }));

    dispatch(
      GetDeleteArticleSlice(
        createDataSetParams({ ...getSearch, timeframe: selectedValue })
      )
    ).then((res) => {
      setPagination(res?.payload?.data?.pagination);
    });
  };

    useEffect(()=>{
   const storeTimeer = setTimeout(() => {
     dispatch(GetDeleteArticleSlice(createDataSetParams(getSearch))).then(
      (res) => {
        setPagination(res?.payload?.data?.pagination);
      }
    );
   },500)

    return ()=> clearTimeout(storeTimeer)
  },[getSearch.search])

  return (
    <>
      <>
        <div className="Small-Wrapper">
          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>Search</label>
                <input
                  type="text"
                  name="search"
                  value={getSearch?.search}
                  onChange={(e) => {
                    setGetSearch((prev) => ({
                      ...prev,
                      fromDate: "",
                      toDate: "",
                    }));
                    setTimeFrame(""); //resetTime Frame

                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }));
                  }}
                  className="form-control"
                  placeholder="Search here"
                />
              </div>
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  name="fromDate"
                  max={new Date().toISOString().split("T")[0]}
                  value={getSearch?.fromDate}
                  onChange={(e) => {
                    setGetSearch((prev) => ({ ...prev, search: "" }));
                    setTimeFrame(""); //resetTime Frame
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }));
                  }}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  name="toDate"
                  max={new Date().toISOString().split("T")[0]}
                  value={getSearch?.toDate}
                  onChange={(e) => {
                    setGetSearch((prev) => ({ ...prev, search: "" }));
                    setTimeFrame(""); //resetTime Frame
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }));
                  }}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button
                  className="Button"
                  onClick={() =>
                    setDataForHold((prev) => ({
                      ...prev,
                      filterTheData: !prev["filterTheData"],
                    }))
                  }
                >
                  Apply
                </button>

                <button className="Button Cancel" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
            <div className="FilterRight">
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control"
                  name="timeframe"
                  value={timeFrame}
                  onChange={handleTimeFrame}
                >
                  <option value="">Select Timeframe</option>{" "}
                  {/* Add an empty value for default */}
                  <option value="today">Today</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                  <option value="this_year">This Year</option>
                </select>
              </div>
            </div>
          </div>
          <div className="TableList">
            <table>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Article ID</th>
                  <th>Article Description</th>
                  <th>Posted On</th>
                  <th>Summary</th>
                  <th>Action</th>
                  {/* <th>Article Status</th> */}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <TableSkeleton />
                ) : Array.isArray(iState) && iState.length > 0 ? (
                  iState?.map((item, index) => {
                    return (
                      <tr>
                        <td>{(pagination.currentPage - 1) * 10 + index + 1}</td>
                        <td>{item?.articleId?.toUpperCase()}</td>
                        <td>
                          {getPlainText(item?.content)?.slice(0, 20)}...
                          <br />
                        </td>
                        <td>{item?.createdAt.slice(0, 10)}</td>
                        <td>
                          {getPlainText(item?.summary)?.slice(0, 20)}...
                          <br />
                        </td>
                        <td>
                          <div className="Actions">
                            <Link
                              to={`/ContentManagement/PublishArticleByAdmin/AllArticleDetails/${item?._id}`}
                              state={item}
                              className="blue"
                            >
                              <i
                                className="fa fa-eye"
                                aria-hidden="true"
                                style={{ color: "green" }}
                              />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <NotFoundData />
                )}
              </tbody>
            </table>
          </div>
        </div>
        {pagination?.totalPages > 1 && (
          <CustomPagination
            activePage={pagination?.currentPage}
            itemsCountPerPage={pagination?.pageSize}
            totalItemsCount={pagination?.totalPages}
            pageRangeDisplayed={5}
            hanldeFetchData={hanldeFetchData}
            itemClass={"page-item"}
            linkClass={"page-link"}
          />
        )}
      </>
    </>
  );
};

export default DeleteArticles;
